import React, {Component} from 'react';
import './index.css'
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import customEmptyImg from "../../images/img_wuzidingyi@2x.png"
import AuthEmptyImg from "../../images/img_wupingtai@2x.png"
import AppEmptyImg from "../../images/img_wuyingyong@2x.png"
import BsyDialog from "../BsyDialog";
import CreateCustomizeKey from "./CreateCustomizeKey";
import BsyIconBtn from "../BsyIconBtn";
import BsyAlert from "../BsyAlert";
import {BsyUtils} from "../../utils/Utils";

class CeateKey extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:"",
            key:"",
            type:"app",
            auth:[],
            customizeList:null,
            appEntryList:[],
            success:false,
            authList:{}
        }
    }

    componentDidMount() {
        this.loadKey()
    }

    loadKey = () =>{
        const {auth} = this.state
        if(this.props.type === "detail") {
            React.axios("/webapi/authlist", {keyid: this.props.kId}).then(res => {
                let appEntryList = [];
                res.data.app.map((res1)=> {
                    res1.apps.map((res2) => {
                        if(res2.select){
                            auth.push(res2.key)
                        }
                        appEntryList.push(res2)
                    })
                })
                res.data.corp.map((res1)=> {
                    res1.group.map((res2) => {
                        if(res2.select){
                            auth.push(res2.key)
                        }
                    })
                })
                res.data.platform.map((res1)=> {
                    res1.group.map((res2) => {
                        if(res2.select){
                            auth.push(res2.key)
                        }
                    })
                })
                this.setState({
                    name: this.props.name,
                    key: this.props.keys,
                    authList: res.data,
                    auth,
                    appEntryList,
                    success:true
                })
            })
        }else if(this.props.type === "create"){
            React.axios("/webapi/getKey",{}).then(res =>{
                React.axios("/webapi/authlist",{}).then(res1 => {
                    let appEntryList = [];
                    res1.data.app.map((res2)=> {
                        res2.apps.map((res3) => {
                            appEntryList.push(res3)
                        })
                    })
                    this.setState({
                        name:res.data.data.name,
                        key:res.data.data.key,
                        authList:res1.data,
                        appEntryList,
                        success:true
                    })
                })
            })
        }

    }

    changeName = (event) =>{
        this.setState({
            name:event.target.value
        })
    }

    selectType = (type) =>{
        return () =>{
            this.setState({
                type:type
            },()=>{
                if(type === "customize"){
                    this.loadFormAuth()
                }
            })
        }
    }

    checkAuth = (k1,k2) =>{
        return () => {
            const {authList, type, auth} = this.state;
            let key = authList[type][k1].group[k2].key;
            if(auth.indexOf(key) > -1){
                auth.splice(auth.indexOf(key),1);
                authList[type][k1].group[k2].select = false;
            }else{
                auth.push(key);
                authList[type][k1].group[k2].select = true;
            }
            this.setState({
                auth,authList
            })
        }
    }

    checkAppAuth = (k) =>{
        return () => {
            const {auth, appEntryList} = this.state;
            let key = appEntryList[k].key;
            if(auth.indexOf(key) > -1){
                auth.splice(auth.indexOf(key),1);
                appEntryList[k].select = false;
            }else{
                auth.push(key);
                appEntryList[k].select = true;
            }
            this.setState({
                auth,appEntryList
            })
        }
    }

    checkAllAuth = (allSelect,k) =>{
        return () =>{
            const {authList, type, auth} = this.state;
            let group = authList[type][k].group;
            if(allSelect){
                group.map(res=>{
                    let key = res.key;
                    if(auth.indexOf(key) > -1){
                        auth.splice(auth.indexOf(key),1);
                        res.select = false;
                    }
                })
            }else{
                group.map(res=>{
                    let key = res.key;
                    auth.push(key);
                    res.select = true;
                })
            }
            this.setState({
                auth,authList
            })
        }
    }

    createSave = () =>{
        const {auth, name, customizeList,key} = this.state;
        let data = {};
        let tipMsg = "";
        let customizeList1 = []
        if(customizeList){
            customizeList.map((res)=>{
                customizeList1.push({
                    appId:res.appId,
                    auth:res.auth,
                    formId:res.formId,
                })
            })
        }

        if(this.props.type === "detail"){
            data = {
                auth,name,keyid:this.props.kId,formauth:customizeList1
            }
            tipMsg = React.language('editer_save_success')
        }else if(this.props.type === "create"){
            data = {
                auth,name,type:1,formauth:customizeList1,key
            }
            tipMsg = React.language('api.CeateKey.success')
        }
        React.axios("/webapi/update",data).then(res=>{
            tipAlert({
                type:"success",
                msg:tipMsg
            })
            this.props.onLoadList && this.props.onLoadList()
            this.props.alertDom && this.props.alertDom.closeAlter && this.props.alertDom.closeAlter()
        })
    }

    closeKey = ()=>{
        this.props.alertDom && this.props.alertDom.closeAlter && this.props.alertDom.closeAlter()
    }

    createCustomizeKey = () =>{
        BsyDialog({
            title: React.language("webhook.key.customize.create"),
            height: 584,
            width: 966,
            noFooter:true,
            onContentCreate: (ref) => {
                return <CreateCustomizeKey mode="create" getFormAuth={this.getFormAuth} elDom={ref}/>
            }
        })
    }

    loadFormAuth = () =>{
        if(this.props.type === "detail"){
            React.axios('/webapi/formauth_list',{keyid:this.props.kId}).then(res=>{
                this.setState({
                    customizeList:res.data.data,
                    success:true
                })
            })
        }else{
            this.setState({
                success:true
            })
        }
    }

    getFormAuth = (data,mode,k) =>{
        const {customizeList} = this.state;
        let customizeList1 = customizeList;
        if(!customizeList){
            customizeList1 = [];
        }
        if(mode === "edit"){
            customizeList1[k] = data;
        }else{
            customizeList1.push(data);
        }
        this.setState({
            customizeList:customizeList1
        })
    }

    editFormAuth = (f,k) =>{
        return ()=>{
            BsyDialog({
                title: React.language("webhook.key.customize.edit"),
                height: 584,
                width: 966,
                noFooter:true,
                onContentCreate: (ref) => {
                    return <CreateCustomizeKey mode="edit" form={f} keyNum={k} getFormAuth={this.getFormAuth} elDom={ref}/>
                }
            })
        }
    }

    removeFormAuth = (k) =>{
        return () =>{
            const {customizeList} = this.state;
            let customizeList1 = customizeList;
            if(!customizeList){
                customizeList1 = [];
            }
            BsyAlert({
                title: React.language("webhook.key.customize.del.title"),
                type: "warning",
                text4Ok: React.language("delete"),
                OkType: "red",
                text4Cancel: React.language("cancel"),
                ok: (value) => {
                    customizeList1.splice(k,1);
                    this.setState({
                        customizeList:customizeList1
                    });
                    tipAlert({
                        type:"success",
                        msg: React.language('delete.success')
                    })
                    return true;
                }
            })
        }
    }

    createApp = () =>{
        BsyUtils.redirectTo(`/bsymember/appstore`,'_blank')
    }

    render() {
        const {name, key, authList, type, appEntryList, customizeList, success} = this.state;
        return (
            <div className="CeateKey">
                {success && <>
                    <div className="key-header-title">
                        <span>{this.props.title}</span>
                        <div className="key-close" onClick={this.closeKey}>
                            <i className="icon-close-large" />
                        </div>
                    </div>
                    <div className="key-header">
                        <div className="key-name">
                            <span>
                                {React.language('webhook.key.name')}
                            </span>
                            <div className="key-input-name">
                                <input type="text" onChange={this.changeName} value={name}/>
                            </div>
                        </div>
                        <div className="key-password">
                            <span>
                                {React.language('webhook.key')}
                            </span>
                            <div className="passwordText">
                                {key}
                            </div>
                        </div>
                        <div className="key-save-btn" onClick={this.createSave}>
                            <span>{React.language('saveInfo.setting')}</span>
                        </div>
                    </div>
                    <div className="key-content">
                        {(this.props.mode === "1" || this.props.type === "create") ? <>
                            <div className="key-menu">
                                <div className={"key-item " + (type === "app" ? "selected" : "")}
                                    onClick={this.selectType("app")}>
                                    <i className="icon-all-app"/>
                                    <span>{React.language('application.system')}</span>
                                </div>
                                <div className={"key-item " + (type === "corp" ? "selected" : "")}
                                    onClick={this.selectType("corp")}>
                                    <i className="icon-bsy-corp"/>
                                    <span>{React.language('address.book.system')}</span>
                                </div>
                                <div className={"key-item " + (type === "platform" ? "selected" : "")}
                                    onClick={this.selectType("platform")}>
                                    <i className="icon-bsy-platform"/>
                                    <span>{React.language('platform.system')}</span>
                                </div>
                                <div className="keyLine" />
                                <div className={"key-item " + (type === "customize" ? "selected" : "")}
                                    onClick={this.selectType("customize")}>
                                    <i className="icon-outsdier-custom-group"/>
                                    <span>{React.language('custom')}</span>
                                </div>
                            </div>
                            <div className="key-feat" key={type}>
                                {
                                    type === "customize" ? <div className="customize-content">
                                        {
                                            (customizeList && customizeList.length > 0) ?
                                            <div className="customize-cont">
                                                <div className="customize-header">
                                                    <div className="customize-title">
                                                        <span>{React.language('webhook.key.customize.title')}</span>
                                                    </div>
                                                    <div className="customize-title">
                                                        <span>{React.language('order.operation')}</span>
                                                    </div>
                                                </div>
                                                <div className="customize-body">
                                                    {
                                                        customizeList && customizeList.map((form,key) => {
                                                            return  <div className="customize-item">
                                                                <div className={"customize-form-name"}>
                                                                    <div className="appName">
                                                                        <div className={`app-icon color-cover-${form.info.appinfo.style.color}`}>
                                                                            <div className={`imgbg-bby-app imgbg-bby-app-${form.info.appinfo.style.icon}`}/>
                                                                        </div>
                                                                        <span>{form.info.appinfo.name}</span>
                                                                    </div>
                                                                    <div className="line-center"/>
                                                                    <div className="formName" style={{marginLeft:form.appinfo ? "5px" : ""}}>
                                                                        <i className={`node-icon icon-bsy-${form.info.forminfo.formType}${form.info.forminfo.hasCoop ? "" : "-flow"} ${form.info.forminfo.icon<=24?`icon-bsy-form-'${form.info.forminfo.icon}`:`icon-new-bsy-form-'${form.info.forminfo.icon}`}`}/>
                                                                        <span>{form.info.forminfo.name}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="customize-btn">
                                                                    <div className="keyBtn edit" onClick={this.editFormAuth(form,key)}>
                                                                        {
                                                                            React.language('edit')
                                                                        }
                                                                    </div>
                                                                    <div className="keyBtn remove" onClick={this.removeFormAuth(key)}>
                                                                        {
                                                                            React.language('remove')
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                                <div className="customize-footer">
                                                    <BsyIconBtn
                                                        type="blue"
                                                        text={React.language('create')}
                                                        iconName="icon-bsy-add"
                                                        click={this.createCustomizeKey}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            <div className="customize-content-empty">
                                                <div className="customize-empty">
                                                    <img src={customEmptyImg} alt=""/>
                                                    <p>{React.language('webhook.key.customize.empty')}</p>
                                                    <div className="createCustomizeBtn" onClick={this.createCustomizeKey}>
                                                        <span>{React.language('webhook.key.customize.create')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div> : authList[type] && <div className="authList">
                                        {
                                            type !== "app" ? authList[type].length > 0 ? authList[type].map((res, key) => {
                                                let allSelect = true
                                                res.group.map((res1, key1) => {
                                                    if (!res1.select) {
                                                        allSelect = false
                                                    }
                                                })
                                                return <div className="authItem">
                                                    <div className="authHeader">
                                                        <div className="authTitle">
                                                            <div className="auth-title">
                                                                {res.name}
                                                            </div>
                                                            <div className="auth-dec">
                                                                {res.dec}
                                                            </div>
                                                        </div>
                                                        <div className="authAllSelect"
                                                            onClick={this.checkAllAuth(allSelect, key)}>
                                                            <i className={allSelect ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                            <span>{React.language('selectAll')}</span>
                                                        </div>
                                                    </div>
                                                    <div className="authItemCheckList">
                                                        <div className="authCheckList left">
                                                            {
                                                                res.group.map((res1, key1) => {
                                                                    return (1 & key1) === 0 &&
                                                                        <div onClick={this.checkAuth(key, key1)}
                                                                            className={"authCheckItem " + (res1.select ? "selected" : "")}>
                                                                            <i className={res1.select ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                            <span>{res1.name}</span>
                                                                        </div>
                                                                })
                                                            }
                                                        </div>
                                                        <div className="authCheckList right">
                                                            {
                                                                res.group.map((res1, key1) => {
                                                                    return (1 & key1) === 1 &&
                                                                        <div onClick={this.checkAuth(key, key1)}
                                                                            className={"authCheckItem " + (res1.select ? "selected" : "")}>
                                                                            <i className={res1.select ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                            <span>{res1.name}</span>
                                                                        </div>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }) : <div className="authEmpty">
                                                <div className="auth-empty">
                                                    <img src={AuthEmptyImg} alt=""/>
                                                    <p>{React.language('webhook.key.auth.empty.title')}</p>
                                                </div>
                                            </div> : <div className="authItem">
                                                <div className="authHeader">
                                                    <div className="authTitle">
                                                        <div className="auth-title">
                                                            {React.language('webhook.key.app.select.title')}
                                                        </div>
                                                        <div className="auth-dec">

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="authItemCheckList">
                                                    {
                                                        appEntryList.length > 0 ? <>
                                                                <div className="authCheckList left">
                                                                    {
                                                                        appEntryList.map((res, key) => {
                                                                            return (1 & key) === 0 && <div
                                                                                className={"authCheckItem app " + (res.select ? "selected" : "")}
                                                                                onClick={this.checkAppAuth(key)}>
                                                                                <i className={res.select ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                                <div className="authAppItem">
                                                                                    <div
                                                                                        className={"app-icon color-cover-" + res.style.color}>
                                                                                        <div
                                                                                            className={"imgbg-small-bsy-app imgbg-bsy-app-" + res.style.icon}/>
                                                                                    </div>
                                                                                    <span>{res.name}</span>
                                                                                </div>
                                                                            </div>
                                                                        })
                                                                    }
                                                                </div>
                                                                <div className="authCheckList right">
                                                                    {
                                                                        appEntryList.map((res, key) => {
                                                                            return (1 & key) === 1 && <div
                                                                                className={"authCheckItem app " + (res.select ? "selected" : "")} onClick={this.checkAppAuth(key)}>
                                                                                <i className={res.select ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                                                <div className="authAppItem">
                                                                                    <div
                                                                                        className={"app-icon color-cover-" + res.style.color}>
                                                                                        <div
                                                                                            className={"imgbg-small-bsy-app imgbg-bsy-app-" + res.style.icon}/>
                                                                                    </div>
                                                                                    <span>{res.name}</span>
                                                                                </div>
                                                                            </div>
                                                                        })
                                                                    }
                                                                </div>
                                                        </>
                                                        :
                                                        <div className="authEmpty">
                                                            <div className="auth-empty">
                                                                <img src={AppEmptyImg} alt=""/>
                                                                <p>{React.language('webhook.key.app.empty.title')}</p>
                                                                <div className="createCustomizeBtn" onClick={this.createApp}>
                                                                    <span>{React.language('webhook.key.create.app')}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </> : <div className="createAllKeyContent">
                            <div className="allKeyCont">
                                <div className="allKetIcon">
                                    <i className="icon-bsy-great" />
                                </div>
                                <p>{React.language('webhook.key.all.detail.tip')}</p>
                            </div>
                        </div>}
                    </div>
                </>}
                
            </div>
        );
    }
}

export default CeateKey;